/** All available async backend checkers for `project module */
export enum ProjectCheckersEnum {
  /** Check whether project(s) with received ID(s) exists(s) */
  PROJECT_ASSERT_EXISTS_BY_ID = 'project/project-assert-exists-by-id',
  /** Check whether project(s) with ID(s) extracted from received DTO(s) exists(s) */
  PROJECT_ASSERT_EXISTS_BY_DTO = 'project/project-assert-exists-by-dto',
  /** Check whether project template(s) with received ID(s) exists(s) */
  PROJECT_TEMPLATE_ASSERT_EXISTS_BY_ID = 'project/project-template-assert-exists-by-id',
  /** Check whether project template(s) with ID(s) extracted from received DTO(s) exists(s) */
  PROJECT_TEMPLATE_ASSERT_EXISTS_BY_DTO = 'project/project-template-assert-exists-by-dto',
  /** Check whether checklist(s) with received ID(s) exists(s) */
  CHECKLIST_ASSERT_EXISTS_BY_ID = 'project/checklist-assert-exists-by-id',
  /** Check whether checklist(s) with ID(s) extracted from received DTO(s) exists(s) */
  CHECKLIST_ASSERT_EXISTS_BY_DTO = 'project/checklist-assert-exists-by-dto',
  /** Check whether checklist template(s) with received ID(s) exists(s) */
  CHECKLIST_TEMPLATE_ASSERT_EXISTS_BY_ID = 'project/checklist-template-assert-exists-by-id',
  /** Check whether checklist template(s) with ID(s) extracted from received DTO(s) exists(s) */
  CHECKLIST_TEMPLATE_ASSERT_EXISTS_BY_DTO = 'project/checklist-template-assert-exists-by-dto',
  /** Check whether checklist type(s) with received ID(s) exists(s) */
  CHECKLIST_TYPE_ASSERT_EXISTS_BY_ID = 'project/checklist-type-assert-exists-by-id',
  /** Check whether checklist type(s) with ID(s) extracted from received DTO(s) exists(s) */
  CHECKLIST_TYPE_ASSERT_EXISTS_BY_DTO = 'project/checklist-type-assert-exists-by-dto',
}
